import React, { useCallback, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import api from '~/services/api';
import { Bar, Lots, Progress } from './styles';

interface IBatchResponse {
  batch_id: number;
  organizer_id: number;
  organizer_name: string;
  event_id: number;
  event_name: string;
  batch_name: string;
  modality_id: number;
  category_id: number;
  modality_name: string;
  category_name: string;
  quantity: number;
  quantity_paid: string;
  quantity_cortesy: string;
  quantity_cancelled: string;
}

interface IBatch {
  eventId: number;
  organizerId: number;
  eventName: string;
  organizerName: string;
  total: number;
  sold: number;
  cortesy: number;
  cancelled: number;
}

interface ILotsCardProps {
  selectedEventId?: number | null;
}

const LotsCard: React.FC<ILotsCardProps> = ({ selectedEventId }) => {
  const [batches, setBatches] = useState<IBatch[]>([]);

  const handleLoadBatches = useCallback(async () => {
    const response = await api.get<IBatchResponse[]>(
      '/sales/organizers/batches',
      {
        params: {
          event_id: selectedEventId,
        },
      }
    );

    const data = response.data.map<IBatch>((batch) => ({
      eventId: batch.event_id,
      organizerId: batch.organizer_id,
      eventName: batch.event_name,
      organizerName: batch.organizer_name,
      total: batch.quantity,
      sold: Number(batch.quantity_paid),
      cortesy: Number(batch.quantity_cortesy),
      cancelled: Number(batch.quantity_cancelled),
    }));

    setBatches(data);
  }, [selectedEventId]);

  useEffect(() => {
    handleLoadBatches();
  }, [handleLoadBatches]);

  return (
    <Lots className="zoom bg-white p-3">
      <div className="d-flex justify-content-between align-items-center mb-2">
        <h2 className="h3 fw-semibold">Vendas atuais por evento</h2>{' '}
        <Link className="h6 fw-normal" to={`${process.env.PUBLIC_URL}/eventos`}>
          Ver todos
        </Link>
      </div>
      <div className="max-height pe-2">
        {batches.map((batch, index) => (
          <div
            key={`${batch.eventId}-${batch.organizerId}-${index}`}
            className="bd-top py-4"
          >
            <h3 className="h6 fw-normal mb-0">{batch.eventName}</h3>
            <p className="d-flex justify-content-between mt-2">
              <span>
                <span className="fw-regular">Vagas:</span>{' '}
                {batch.total === 0 ? 'Ilimitado' : batch.total}
              </span>
              <span>
                <span className="fw-regular">Vendidos:</span> {batch.sold}
              </span>
              <span>
                <span className="fw-regular">Cortesias:</span> {batch.cortesy}
              </span>
              <span>
                <span className="fw-regular">Cancelados:</span>{' '}
                {batch.cancelled}
              </span>
            </p>
            <Bar className="ms-auto">
              <Progress
                width={batch.total > 0 ? (batch.sold / batch.total) * 100 : 0}
              />
            </Bar>
          </div>
        ))}
      </div>
    </Lots>
  );
};

export default LotsCard;
